import { Box, Divider, Grid, Paper, Typography } from '@mui/material';
import React, { useState } from 'react';

import { Button } from '../../../../components/buttons';
import { Dropdown } from '../../../../components/dropDowns';
import { DropdownProps } from '../../../../components/dropDowns/Dropdown.types';
import { TEXT_CONTENT } from '../../../../utils/constants';
import { IFacilityChooserProps } from './FacilityChooser.types';

export const FacilityChooser = React.forwardRef(
  function FacilityChooserComponent(
    { options = [], onApply, onCancel, value }: IFacilityChooserProps,
    ref
  ) {
    const [currentFacility, setCurrentFacility] =
      useState<DropdownProps['value']>(value);
    const onfacilityChange = (v: DropdownProps['value']) => {
      setCurrentFacility(v);
    };

    return (
      <Box ref={ref} sx={{ width: '100%', height: '100vh' }}>
        <Grid
          container
          spacing={0}
          direction="column"
          alignItems="center"
          justifyContent="center"
          sx={{ minHeight: '100%', width: '100%' }}
        >
          <Paper
            elevation={3}
            sx={{
              maxWidth: '32rem',
              p: '2rem',
              width: '100%',
            }}
          >
            <Typography sx={{ fontSize: '1.12rem', fontWeight: 400 }}>
              {TEXT_CONTENT.SELECT_A_FACILITY}
            </Typography>
            <Divider
              orientation="horizontal"
              sx={{ mb: '3rem', mx: '-2rem', mt: '1rem' }}
            />
            <Dropdown
              id="facility-chooser-1"
              style={{ width: '100%', height: '2.5rem' }}
              options={options}
              value={currentFacility}
              onChange={onfacilityChange}
              placeHolder="Choose a Facility"
              label={TEXT_CONTENT.SELECT_A_FACILITY}
              autoFocus
            />
            <Box
              sx={{
                display: 'flex',
                mt: '2rem',
                justifyContent: 'flex-end',
                gap: '1rem',
                height: '2.5rem',
              }}
            >
              <Button onClick={() => onApply?.(currentFacility)}>Apply</Button>
            </Box>
          </Paper>
        </Grid>
      </Box>
    );
  }
);
export default FacilityChooser;
